import { useState, useEffect } from "react";
import { useWeb3React } from "@web3-react/core";
import { Rings } from "react-loader-spinner";

import Utils from "./Utils";
import { Page } from "../api";
import { Alert } from "../components/Alert";
import { WorkCard } from "../components/Cards";
import { LionImage } from "../components/Images";
import { Counter } from "../components/Counter";
import { ErrorModal } from "../components/Modal";
import {
  getErrorMessageFromTxResult,
  getTxHashFromTxResult,
} from "../utils/utils";
import { GradientButton, LinkButton } from "../components/Buttons";
import "./whitelist.css";
import { web3LionTravelerInstance } from "../Web3/hook";

const Whitelist = () => {
  let { library, account, active, chainId } = useWeb3React();
  const page = Page();
  const api = {
    ...page.api.whitelist.wallet,
    ...{
      headers: page.headers,
      key: "address",
    },
  };
  const [email, setEmail] = useState("");
  const [isSubscribeStart, setIsSubscribeStart] = useState(false);
  const [isWhitelisted, setIsWhitelisted] = useState(false);
  const [startDate, setStartDate] = useState();
  const [errorContent, setErrorContent] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isRunningTx, setIsRunningTx] = useState(false);
  const [transactionResult, setTransactionResult] = useState("");
  const [transactionHash, setTransactionHash] = useState("");

  const text = (
    <>
      Being Whitelisted will allow you to:
      <br />
      <ul className="text-white-50 list-whitelist">
        <li>access to Lion NFTs before public launch of each edition</li>
        <li>avoid Gas Wars</li>
        <li>a 50% discount on the price of our Lion NFTs!</li>
      </ul>
      Be the first to know!
    </>
  );

  const countDownText = (
    <>
      Waiting the minitng phase? Take a look at the roadmap to know more!
      <br />
      <br />
      lst edition Lion Travelers mint countdown
    </>
  );

  const addToBackend = async () => {
    const data = { ...api.create.params, address: account, email: email };
    const res = await Utils.fetchCreate(api, data);
    if (res) return true;
  };

  const handleSubmit = async (e) => {
    if (!active) {
      setErrorContent("Please connect wallet.");
      setShowErrorModal(true);
      return;
    }
    try {
      await web3LionTravelerInstance().methods.addWhitelist([account]).call({ from: account });
      setIsRunningTx(true);
      const result = await web3LionTravelerInstance().methods
        .addWhitelist([account])
        .send({ from: account });
      addToBackend();
      setIsRunningTx(false);
      setTransactionResult("success");
      setTransactionHash(result.transactionHash);
      setIsWhitelisted(true);
    } catch (err) {
      setIsRunningTx(false);
      if (err.code === 4001) {
        setErrorContent(err.message);
        setShowErrorModal(true);
      } else {
        setErrorContent(getErrorMessageFromTxResult(err));
        setShowErrorModal(true);
      }
    }
  };

  const handleLoadMap = (e) => {
    e.preventDefault();
    window.location.href = "/#roadmap";
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      let res = await Utils.fetchGet(page.api.whitelist.status.url);
      if (res) {
        let now = new Date().getTime() / 1000;
        if (!res.data.status) {
          setIsSubscribeStart(false);
          return;
        }
        if (res.data.start_at > now) {
          setStartDate(res.data.start_at);
          setIsSubscribeStart(false);
        } else setIsSubscribeStart(true);
      }
    }
    fetchData()
    setInterval(fetchData, 5000);
  }, [page]);

  useEffect(() => {
    if (account) {
      (async () => {
        try {
          let whitelisted = await web3LionTravelerInstance().methods
            .isWhitelisted(account)
            .call({ from: account });
          setIsWhitelisted(whitelisted);
        } catch (err) {
          throw err;
        }
      })();
    }
  }, [account]);

  return (
    <section id="mint">
      <div className="container">
        <div className="row">
          <ErrorModal
            title={"Error"}
            content={errorContent}
            onClose={() => setShowErrorModal(false)}
            show={showErrorModal}
          />
          <LionImage />
          {isWhitelisted ? (
            <WorkCard
              title="Countdown Mint Lion Travelers NFT"
              text={countDownText}
            >
              Coming soon!
              <br />
              <br />
              <GradientButton text="LOADMAP" onClick={handleLoadMap} />
            </WorkCard>
          ) : isSubscribeStart ? (
            <WorkCard title="Private sale whitelist" text={text}>
              <div className="row box-pre-input">
                <div className="col-12">
                  <input
                    type="email"
                    className="text-white-50 bg-none w-full input-btn"
                    placeholder="email"
                    name="email"
                    inputMode="email"
                    value={email}
                    onChange={handleEmailChange}
                  />
                </div>
              </div>
              <GradientButton text="Submit" onClick={handleSubmit} />
              {isRunningTx ? (
                <div className="d-flex justify-content-center text-center">
                  <Rings color="#555" height={50} width={50} />
                </div>
              ) : (
                ""
              )}
              {transactionResult !== "" ? (
                <Alert status={transactionResult}>
                  <LinkButton
                    classname=""
                    target="blank"
                    link={"https://rinkeby.etherscan.io/tx/" + transactionHash}
                    text="Show detail in etherscan"
                  />
                </Alert>
              ) : (
                ""
              )}
            </WorkCard>
          ) : (
            <WorkCard
              title="Countdown Mint Lion Travelers NFT"
              text={countDownText}
            >
              <Counter endDate={startDate} isStart={setIsSubscribeStart} />
            </WorkCard>
          )}
        </div>
      </div>
    </section>
  );
};

export default Whitelist;
